import { HiddenCanvas, utils } from '../utils.js';
import { isIOS } from '../core/environment.js';
import { myToolbar } from '../tools/toolbar.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';

const getSafariThumbnail = (hidden) => {

    const getCanvas = document.getElementsByTagName('canvas');
    const canvas = getCanvas[0];

    const myX = 90, myY = 60, myW = game.scale.width - 90;
    const myH = Math.floor(myW * 0.6363);

    // make the background white
    hidden.ctx.fillStyle = "#FFF";
    hidden.ctx.fillRect(0, 0, 110, 70);

    hidden.ctx.drawImage(
        canvas, myX, myY, myW, myH,
        0, 0, 110, 70
    );

    const result = hidden.canvas.toDataURL('image/jpeg', 0.5);
    hidden.remove();

    return result;
};

export const getThumbnail = () => {

    const hidden = new HiddenCanvas(110, 70);

    if (isIOS || window.safari) {
        return getSafariThumbnail(hidden);
    }

    let myZoom = game.cameras.cameras[0].zoom;

    let myW = 2 * 880 / myZoom; // the width of the clipping
    let myH = 2 * 560 / myZoom; // the height of the clipping

    let canvasPoint = utils.returnPoint((game.scale.width / 2) + 1, (game.scale.height / 2) + 1);

    let myX = canvasPoint.x - (myW / 2); // the top left co-ordinates of the clipping
    let myY = canvasPoint.y - (myH / 2);

    let angleToRotate = game.cameras.main.rotation

    // make the background white
    hidden.ctx.fillStyle = "#FFF";
    hidden.ctx.fillRect(0, 0, 110, 70);

    hidden.ctx.translate(hidden.canvas.width / 2, hidden.canvas.height / 2);
    hidden.ctx.rotate(angleToRotate);

    if (beads.rt) {
        beads.rt.forEach((element, i) => {

            let _x = myX - element.canvas.x;
            let _y = myY - element.canvas.y;
            let _w = myW;
            let _h = myH;
    
            let px = -110, py = -70, pw = 220, ph = 140;
    
            if (_w > 0 && _h > 0) {
                hidden.ctx.drawImage(
                    element.canvas.canvas,
                    _x, _y, _w, _h,
                    px, py, pw, ph
                );
            }
        });
    }

    hidden.ctx.rotate(-angleToRotate);
    hidden.ctx.translate(-hidden.canvas.width/2, -hidden.canvas.height/2);

    const result = hidden.canvas.toDataURL('image/jpeg', 0.5);
    hidden.remove();

    return result;
};